import {ClickEvent} from "../../../../../infrastructure/models/analytics/click-event";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";

export class MatchEventModuleTabClickAnalyticsEvent extends ClickEvent {
  gameId: Number;
  status: ANALYTICS.GAME_STATUSES;
  tab: String;

  constructor(params) {
    super('', 'tab_click', 'match-details');

    this.gameId = params.gameId;
    this.status = params.status;
    this.tab = params.tab;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.tab = this.tab;

    return properties;
  }
}